  <script>
  export default {
    name: "SvgIcon",
    props: {
        publicPage: { 
            type: Object,
            default: null
        },
        showMenu: { 
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: "#ffffff",
        }
    }    
  };
  </script>
<template> 
    <div :style="{color:color}"> 
        <!-- Default -->
        <svg v-if="publicPage.svg_transition == 'default'" viewBox="0 0 100 20" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="20" class="svg-icon">
        <path d="M0,19 100,19 100,20 0,20 Z" fill="currentColor" />
        </svg>

        <!-- Defaults -->
        <svg v-if="publicPage.svg_transition == 'defaults'" viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="40" class="svg-icon">
          <path d="M0,10 100,10 100,0 0,0 Z" fill="currentColor" opacity="0.5" />
          <path d="M0,20 100,20 100,10 0,10 Z" fill="currentColor" opacity="0.7" />
          <path d="M0,30 100,30 100,20 0,20 Z" fill="currentColor" opacity="0.98" />
        </svg>

        <!-- Many Waves -->
        <svg v-if="publicPage.svg_transition == 'manyWaves'" preserveAspectRatio="none" viewBox="0 0 240 20" xmlns="http://www.w3.org/2000/svg" width="100%" height="50" class="svg-icon">
        <path d="M0,10 C20,0 40,20 60,10  
                C80,0 100,20 120,10  
                C140,0 160,20 180,10  
                C200,0 220,20 240,10 L240,20 L0,20 Z" fill="currentColor" />
        </svg>

        <!-- Waves -->
        <svg v-if="publicPage.svg_transition == 'waves'" viewBox="0 0 100 20" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="70" class="svg-icon">
        <path d="M0,10 C20,0 40,20 60,10 C80,0 100,20 120,10 L100,20 L0,20 Z" fill="currentColor" />
        </svg>

        <!-- Bowl Up -->
        <svg v-if="publicPage.svg_transition == 'bowlUp'" viewBox="0 0 100 50" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="50" class="svg-icon">
        <path d="M0,50 H100 L100,50 Q50,10 0,50 Z" fill="currentColor" />
        </svg>

        <!-- Bowl Down -->
        <svg v-if="publicPage.svg_transition == 'bowlDown'" viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="30" class="svg-icon">
        <path d="M0,0 Q40,30 100,0 L100,30 L0,30 Z" fill="currentColor" />
        </svg>

        <!-- Triangle Left -->
        <svg v-if="publicPage.svg_transition == 'triangleLeft'" viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="30" class="svg-icon">
            <polygon points="0,30 100,30 0,0" fill="currentColor" />
        </svg>

        <!-- Triangle Right -->
        <svg v-if="publicPage.svg_transition == 'triangleRight'" viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="30" class="svg-icon">
            <polygon points="0,30 100,30 100,0" fill="currentColor" />
        </svg>

        <!-- Triple Triangle Right -->
        <svg v-if="publicPage.svg_transition == 'tripleTriangleRight'" viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="30" class="svg-icon">
             <polygon points="0,30 100,30 100,0" fill="currentColor" opacity="0.98" />
            <polygon points="0,30 100,30 0,0" fill="currentColor" opacity="0.2" />    
            <polygon points="0,40 80,40 0,0" fill="currentColor" opacity="0.4" />
        </svg>

        <svg  v-if="publicPage.svg_transition == 'tripleWaves'" viewBox="0 0 1440 240" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100" class="svg-icon">
           
            <path fill="currentColor" opacity="0.20" d="M0,160 C80,140 180,180 260,150 C360,120 460,200 560,160 C660,120 760,180 860,150 C960,120 1100,200 1200,170 C1300,140 1380,190 1440,160 L1440,240 L0,240 Z"/>
            <path fill="currentColor" opacity="0.50" d="M0,176 C100,150 200,190 300,160 C400,130 500,210 600,170 C700,130 800,190 900,160 C1000,130 1140,210 1240,180 C1340,150 1400,200 1440,176 L1440,240 L0,240 Z"/>
            <path fill="currentColor" opacity="0.97" d="M0,192 C120,170 220,200 320,180 C420,160 520,220 640,190 C760,160 880,210 1000,180 C1120,150 1260,220 1360,190 C1400,178 1420,200 1440,192 L1440,240 L0,240 Z"/> 
        </svg>
        
        <!-- Triple Bowl Down -->
        <svg  v-if="publicPage.svg_transition == 'tripleBowlDown'" viewBox="0 0 1920 160" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="80" class="svg-icon">          
          <path d="M0,100 Q960,200 1920,100 L1920,160 L0,160 Z" fill="currentColor" opacity="0.5"/>
          <path d="M0,80 Q960,180 1920,120 L1920,160 L0,160 Z" fill="currentColor" opacity="0.98"/>
          <path d="M0,60 Q960,200 1920,60 L1920,160 L0,160 Z" fill="currentColor" opacity="0.3"/>
        </svg>
        
        <!-- Triple triangel left -->
        <svg  v-if="publicPage.svg_transition == 'tripleTriangleLeft'" viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="30" class="svg-icon">          
          <polygon points="0,30 100,30 0,0" fill="currentColor" opacity="0.98" />
          <polygon points="100,30 40,30 100,0" fill="currentColor" opacity="0.4" />    
          <polygon points="100,40 0,20 100,0" fill="currentColor" opacity="0.2" />
        </svg>


    </div>
    <div v-if="showMenu" class="SvgTransition-menu opacity-admin-bg"> 
       <p>Välj övergång mellan bild och text.</p>
        <div>
          <!-- Default -->
          <div style="display: flex; gap: 6px; margin-bottom: 5px;">
            <svg viewBox="0 0 100 20" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'default'" class="svg-icon-minimized" v-tooltip="'Vanlig Rak linje'" :style="{ opacity: publicPage.svg_transition == 'default' ? 1 : 0.4 }">
            <path d="M0,19 100,19 100,20 0,20 Z" fill="currentColor" />
            </svg>
            
            <svg viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'defaults'" class="svg-icon-minimized" v-tooltip="'3 linjer'" :style="{ opacity: publicPage.svg_transition == 'defaults' ? 1 : 0.4 }">
            <path d="M0,10 100,10 100,0 0,0 Z" fill="currentColor" opacity="0.5" />
            <path d="M0,20 100,20 100,10 0,10 Z" fill="currentColor" opacity="0.7" />
            <path d="M0,30 100,30 100,20 0,20 Z" fill="currentColor" opacity="0.98" />
            </svg>

            
              
            <!-- Waves -->
            <svg viewBox="0 0 100 20" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'waves'" class="svg-icon-minimized" v-tooltip="'Vågor'" :style="{ opacity: publicPage.svg_transition == 'waves' ? 1 : 0.4 }">
            <path d="M0,10 C20,0 40,20 60,10 C80,0 100,20 120,10 L100,20 L0,20 Z" fill="currentColor" />
            </svg>

            <!-- Many Waves -->
            <svg  preserveAspectRatio="none" viewBox="0 0 240 20" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'manyWaves'" class="svg-icon-minimized" v-tooltip="'Många vågor'" :style="{ opacity: publicPage.svg_transition == 'manyWaves' ? 1 : 0.4 }">
            <path d="M0,10 C20,0 40,20 60,10  
                    C80,0 100,20 120,10  
                    C140,0 160,20 180,10  
                    C200,0 220,20 240,10 L240,20 L0,20 Z" fill="currentColor" />
            </svg>

            <!-- tripleWaves -->
            <svg  viewBox="0 0 1440 240" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"  width="60px" height="15px" @click="publicPage.svg_transition = 'tripleWaves'" class="svg-icon-minimized" v-tooltip="'Trippla vågor'" :style="{ opacity: publicPage.svg_transition == 'tripleWaves' ? 1 : 0.4 }">
              
                <path fill="currentColor" opacity="0.20" d="M0,160 C80,140 180,180 260,150 C360,120 460,200 560,160 C660,120 760,180 860,150 C960,120 1100,200 1200,170 C1300,140 1380,190 1440,160 L1440,240 L0,240 Z"/>
                <path fill="currentColor" opacity="0.50" d="M0,176 C100,150 200,190 300,160 C400,130 500,210 600,170 C700,130 800,190 900,160 C1000,130 1140,210 1240,180 C1340,150 1400,200 1440,176 L1440,240 L0,240 Z"/>
                <path fill="currentColor" opacity="0.97" d="M0,192 C120,170 220,200 320,180 C420,160 520,220 640,190 C760,160 880,210 1000,180 C1120,150 1260,220 1360,190 C1400,178 1420,200 1440,192 L1440,240 L0,240 Z"/> 
            </svg>

            <!-- Bowl Up -->
            <svg viewBox="0 0 100 50" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'bowlUp'" class="svg-icon-minimized" v-tooltip="'Buktar uppåt'" :style="{ opacity: publicPage.svg_transition == 'bowlUp' ? 1 : 0.4 }">
            <path d="M0,50 H100 L100,50 Q50,10 0,50 Z" fill="currentColor" />
            </svg>
          </div>
          <div style="display: flex; gap: 6px;">
            <!-- Bowl Down -->
            <svg viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'bowlDown'" class="svg-icon-minimized" v-tooltip="'Buktar neråt'" :style="{ opacity: publicPage.svg_transition == 'bowlDown' ? 1 : 0.4 }">
            <path d="M0,0 Q40,30 100,0 L100,30 L0,30 Z" fill="currentColor" />
            </svg>
            
            <!-- Triple Bowl Down -->
            <svg viewBox="0 0 1920 160" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'tripleBowlDown'" class="svg-icon-minimized" v-tooltip="'Buktar neråt x 3'" :style="{ opacity: publicPage.svg_transition == 'tripleBowlDown' ? 1 : 0.4 }">
              <path d="M0,100 Q960,200 1920,100 L1920,160 L0,160 Z" fill="currentColor" opacity="0.5"/>
              <path d="M0,80 Q960,180 1920,120 L1920,160 L0,160 Z" fill="currentColor" opacity="0.9"/>
              <path d="M0,60 Q960,200 1920,60 L1920,160 L0,160 Z" fill="currentColor" opacity="0.3"/>
            </svg>

            <!-- Triangle Left -->
            <svg viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'triangleLeft'" class="svg-icon-minimized" v-tooltip="'Lutande åt höger'" :style="{ opacity: publicPage.svg_transition == 'triangleLeft' ? 1 : 0.4 }">
                <polygon points="0,30 100,30 0,0" fill="currentColor" />
            </svg>
            
            <!-- Triple Triangle Left -->
            <svg viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'tripleTriangleLeft'" class="svg-icon-minimized" v-tooltip="'Lutande åt höger '" :style="{ opacity: publicPage.svg_transition == 'tripleTriangleLeft' ? 1 : 0.4 }">             
                  <polygon points="0,30 100,30 0,0" fill="currentColor" opacity="0.98" />
                  <polygon points="100,30 40,30 100,0" fill="currentColor" opacity="0.4" />    
                  <polygon points="100,40 0,20 100,0" fill="currentColor" opacity="0.2" />             
            </svg>
            
            <!-- Triple Triangle Right -->
            <svg viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'tripleTriangleRight'" class="svg-icon-minimized" v-tooltip="'Lutande åt vänster '" :style="{ opacity: publicPage.svg_transition == 'tripleTriangleRight' ? 1 : 0.4 }">             
              <polygon points="0,30 100,30 100,0" fill="currentColor" opacity="0.98" />
              <polygon points="0,30 100,30 0,0" fill="currentColor" opacity="0.2" />    
              <polygon points="0,40 80,40 0,0" fill="currentColor" opacity="0.4" />
            </svg>

            <!-- Triangle Right -->
            <svg  viewBox="0 0 100 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="60px" height="15px" @click="publicPage.svg_transition = 'triangleRight'" class="svg-icon-minimized" v-tooltip="'Lutande åt vänster'" :style="{ opacity: publicPage.svg_transition == 'triangleRight' ? 1 : 0.4 }">
                <polygon points="0,30 100,30 100,0" fill="currentColor" />
            </svg>
          </div>
        </div>
    </div>
</template>
  
  
  <style scoped>
  .svg-icon {
    display: block;
    position: absolute;
    bottom: -1px;
    width: 100%;
  }
  .svg-icon-minimized {
    display: block;
    opacity: 0.4;
    bottom: 0px;
    width: 60px;
    cursor: pointer;
  }
  
  .svg-icon-minimized:hover {
    display: block;
    bottom: 0px;
    width: 60px;
    opacity: 1 !important;
  }

  .SvgTransition-menu {
    position: absolute; 
    z-index:10; 
    bottom: -100px; 
    right: -10px; 
    padding:10px; 
    font-size: 13px;
  }

  .opacity-admin-bg {
    border-radius: 3px;
    padding: 7px;
    background-color: rgb(115 94 80 / 85%);
    color: white;
  }
  </style>
  